import { Component } from 'react';
import AgentPhoto from 'legacy/javascripts/components/agent_photo.es6.jsx';
import { DateTime, usaDateFormat } from 'common/utils/date';

class HeadlineClass extends Component {
  constructor() {
    super();
    this.headerStyle = {
      color: '#335168',
      fontSize: '40px',
      fontWeight: '200',
      margin: '0',
    };
    this.dateStyle = {
      color: '#77777c',
      fontWeight: '300',
      fontSize: '18px',
      margin: '0',
    };
  }

  render() {
    return (
      <div style={{ margin: '30px 0 30px 0' }}>
        {this.props.employee.image && (
          <div style={{ float: 'left', margin: '12px 15px' }}>
            <AgentPhoto
              height="70px"
              width="auto"
              image={this.props.employee.image}
            />
          </div>
        )}
        <div style={{ display: 'inline-block' }}>
          <div
            style={this.headerStyle}
            data-notranslate
            data-testid="employee-name-title"
          >
            {this.props.employee.label}
          </div>
          <div style={this.dateStyle}>
            {DateTime.fromFormat(this.props.startDate, usaDateFormat).toLocaleString(DateTime.DATE_SHORT)}{' '}
            to {DateTime.fromFormat(this.props.endDate, usaDateFormat).toLocaleString(DateTime.DATE_SHORT)}
          </div>
        </div>
      </div>
    );
  }
}

export default HeadlineClass;
